import React,{useEffect, useState} from 'react'
import AppSelect from '../../../components/AppInput/AppSelect'
import { Add, Delete } from '@mui/icons-material';



const CounterRow = ({counterDetails,announceToken}) =>{

    const [counterToken, setCounterToken] = useState(null);
    useEffect(()=>{
        if(counterDetails && counterDetails.workLocation == announceToken.workLocation){
            setCounterToken(announceToken);
        }
    },[announceToken])


    return (
        counterDetails &&
        <>
            <th className='bg-primary text-white'>{counterDetails.workLocation} </th>
            <th className='bg-danger text-white'>{counterToken?.firstName.toUpperCase()}. </th>
            <td className='bg-danger text-white'>{counterToken?.tokenPrefix}-{counterToken?.tokenNo}</td>

        </>
    )


}


function MultipleCounterComponent({userDDList,announceToken}) {

    const [selectedCounter,setSelectedCounter] = useState(null)
    const [counterList,setCounterList] = useState([]);
    const [showCounterSelection,setShowCounterSelection] = useState(false);
    

    const addCounter = () =>{
        setCounterList(()=>[...counterList,selectedCounter]);
    }

    const removeItem = (i) =>{
        console.log(i);
        let _counterList = [...counterList]
        _counterList.splice(i,1)
        setCounterList(_counterList)
    }

    useEffect(()=>{
        let _counterList = localStorage.multipleCounterList;
        try{
            setCounterList(JSON.parse(_counterList));
        } catch(error){
            console.log(error);
        }
    },[])

    const saveCounterConfig = () =>{
        if(counterList.length > 0){
            localStorage.setItem( 'multipleCounterList', JSON.stringify(counterList))
            setShowCounterSelection(false);
        }
    }

  return (
        <>
            {userDDList && showCounterSelection &&
                <div className='row mb-3'>
                    <div className='col-md-6'>
                        <AppSelect
                            options={[ {value:"",label:"Select a Counter"},...userDDList]}
                            value={selectedCounter}
                            setValue={setSelectedCounter}
                            label="Select Counter" 
                            optionLabel = "label"
                        />
                    </div>
                    <div className='col-md-6'>
                        <button className='btn btn-outline-primary' onClick={addCounter} ><Add/> </button>
                        {/* <button className='btn btn-danger mx-2' onClick={()=>setShowCounterSelection(false)} >Close Counter Selection</button> */}
                        <button className='btn btn-success mx-2' onClick={saveCounterConfig} >Save Counter Configuration (Device Only) </button>
                    </div>
                </div>
            }
            <table className='table'>
                <thead>
                    <tr onClick={()=>setShowCounterSelection(true)}>
                        <th width="20%" className='bg-dark text-white'>Counter #</th>
                        <th width="35%" className='bg-dark text-white'> Visitor Name</th>
                        <th className='bg-dark text-white'>Token #</th>
                    </tr>
                </thead>
                <tbody>
                    {counterList.map((counterDetails,i) =>
                        <tr key={i}>
                            <CounterRow key={i} counterDetails={counterDetails} announceToken={announceToken} i={i} removeItem={removeItem}></CounterRow>
                            {showCounterSelection && <td><button className='btn btn-outline-danger' onClick={()=>removeItem(i)} ><Delete/></button></td> }
                        </tr>
                    )}
                </tbody>

            </table>
            
        </>

    )
}

export default MultipleCounterComponent


/*
            {selectedCounter !== null && 
                <div className='col-md-6 bg-dark text-white p-3 text-center'>
                    <h2>{selectedCounter.firstName}</h2>
                </div>
            }
            {selectedCounter !== null && counterToken &&
                <div className='col-md-6'>
                    <div className='row'>
                        <div className='col-md-12 bg-danger text-white p-3 text-center'>
                            <h2>{counterToken.tokenPrefix}-{counterToken.tokenNo}</h2>
                        </div>
                        <div className='col-md-12  p-3 text-center'>
                            <h2>{counterToken.firstName === "" ? "-" : counterToken.firstName}</h2>
                        </div>
                    </div>
                </div>
            }
*/